{
// Elude product page: gallery (thumbs, arrows, swipe, video slot), option selectors → variant,
// UK-time 3pm dispatch countdown, accordions, "Complete the fit" cross-sell adds.
// Customer-facing text comes from window.EludeStrings (locales/en.default.json → "elude"), English fallbacks below.
const tr = (key, fallback, vars = {}) => String(window.EludeStrings?.[key] ?? fallback).replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
const init = () => {
  const root = document.querySelector('[data-e-pdp]');
  if (!root || root.dataset.eBound) return;
  root.dataset.eBound = '1';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Gallery ---------- */
  const gal = root.querySelector('[data-e-gal]');
  if (gal) {
    const track = gal.querySelector('[data-e-track]');
    const slides = [...track.children];
    const thumbs = [...gal.querySelectorAll('.e-gal__thumb')];
    const dots = [...gal.querySelectorAll('.e-gal__dots button')];
    const idxEl = gal.querySelector('[data-e-idx]');
    let i = 0;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      slides.forEach((s, k) => s.setAttribute('aria-hidden', String(k !== i)));
      thumbs.forEach((t, k) => { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', String(k === i)); });
      const strip = thumbs[i]?.parentElement;
      if (strip && strip.scrollHeight > strip.clientHeight) strip.scrollTo({ top: thumbs[i].offsetTop - (strip.clientHeight - thumbs[i].offsetHeight) / 2, behavior: reduce.matches ? 'auto' : 'smooth' });
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      if (idxEl) idxEl.textContent = i + 1;
      slides.forEach((s, k) => {
        const v = s.querySelector('video');
        if (!v) return;
        if (k === i) { if (!v.src && v.dataset.eSrc) v.src = v.dataset.eSrc; if (!reduce.matches) v.play().catch(() => {}); else v.controls = true; }
        else v.pause();
      });
    };
    gal.addEventListener('click', (e) => {
      const g = e.target.closest('[data-e-goto]'); if (g) return go(+g.dataset.eGoto);
      if (e.target.closest('[data-e-prev]')) return go(i - 1);
      if (e.target.closest('[data-e-next]')) return go(i + 1);
    });
    gal.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { go(i + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(i - 1); e.preventDefault(); }
    });
    let x0 = null;
    const stage = gal.querySelector('.e-gal__stage');
    stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); x0 = null; });
  }

  /* ---------- Variants ---------- */
  const dataEl = root.querySelector('[data-e-variants]');
  const data = dataEl ? JSON.parse(dataEl.textContent) : null;
  const fmt = (cents) => {
    const v = (cents / 100).toFixed(2);
    const tpl = (data && data.money) || '£{{amount}}';
    return tpl.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };
  const groups = [...root.querySelectorAll('[data-e-option]')];
  const selected = () => groups.map((g) => g.querySelector('.e-size__btn.is-on')?.dataset.value);
  const find = (opts) => data.variants.find((v) => v.options.every((o, k) => o === opts[k]));

  const refreshAvailability = () => {
    const sel = selected();
    groups.forEach((g, gi) => {
      g.querySelectorAll('.e-size__btn').forEach((b) => {
        const opts = sel.slice(); opts[gi] = b.dataset.value;
        const v = find(opts);
        const out = !v || !v.available;
        b.classList.toggle('is-out', out);
        b.setAttribute('aria-label', out ? tr('sizeSoldOut', '{size} sold out', { size: b.dataset.value }) : b.dataset.value);
      });
    });
  };

  const setVariant = (v) => {
    if (!v) return;
    root.querySelectorAll('[data-e-variant-input]').forEach((inp) => (inp.value = v.id));
    const priceEl = root.querySelector('[data-e-price]');
    if (priceEl) {
      const tax = priceEl.querySelector('.e-info__tax');
      priceEl.innerHTML = v.compare > v.price
        ? `<span class="e-info__now e-info__now--sale">${fmt(v.price)}</span><s class="e-info__was">${fmt(v.compare)}</s>`
        : `<span class="e-info__now">${fmt(v.price)}</span>`;
      if (tax) priceEl.appendChild(tax);
    }
    root.querySelectorAll('[data-e-kl]').forEach((el) => (el.textContent = fmt(Math.floor(v.price / +root.dataset.kl))));
    root.querySelectorAll('[data-e-cp]').forEach((el) => (el.textContent = fmt(Math.floor(v.price / +root.dataset.cp))));
    const btn = root.querySelector('[data-e-atc]');
    const lab = root.querySelector('[data-e-atc-label]');
    if (btn && lab) {
      btn.disabled = !v.available;
      btn.toggleAttribute('aria-disabled', !v.available);
      lab.textContent = v.available ? tr('addToBag', 'Add to bag — {price}', { price: fmt(v.price) }) : tr('soldOut', 'Sold out');
    }
    const stock = root.querySelector('[data-e-stock]');
    if (stock) {
      const low = +root.dataset.low;
      stock.className = 'e-stock';
      if (!v.available) { stock.classList.add('e-stock--out'); stock.innerHTML = `<span class="e-stock__dot e-stock__dot--out"></span>${tr('soldOutInSize', 'Sold out in this size')}`; }
      else if (v.qty != null && v.qty <= low) { stock.classList.add('e-stock--low'); stock.innerHTML = `<span class="e-stock__dot e-stock__dot--low"></span>${tr('lowStock', 'Low stock — only {quantity} left', { quantity: v.qty })}`; }
      else stock.innerHTML = `<span class="e-stock__dot"></span>${data.inStock}`;
    }
    const thr = +root.dataset.threshold, free = root.querySelector('[data-e-free]'), bar = root.querySelector('[data-e-free-bar]');
    if (free) free.textContent = v.price >= thr ? tr('freeDelivery', 'Free UK delivery on this order') : tr('awayFromFree', '{amount} away from free UK delivery', { amount: fmt(thr - v.price) });
    if (bar) bar.style.width = Math.min(100, (v.price / thr) * 100) + '%';
    const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    document.dispatchEvent(new CustomEvent('elude:variant', { detail: { variant: v, labels: groups.map((g) => g.querySelector('legend')?.childNodes[0]?.textContent.replace('—', '').trim()), values: selected() } }));
  };

  if (data && groups.length) {
    groups.forEach((g) => g.addEventListener('click', (e) => {
      const b = e.target.closest('.e-size__btn'); if (!b) return;
      g.querySelectorAll('.e-size__btn').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', String(x === b)); });
      const chosen = g.querySelector('[data-e-chosen]'); if (chosen) chosen.textContent = b.dataset.value;
      refreshAvailability();
      setVariant(find(selected()));
    }));
    refreshAvailability();
  }

  /* ---------- 3pm UK dispatch countdown ---------- */
  const cd = root.querySelector('[data-e-countdown]');
  if (cd) {
    const cutoff = +root.dataset.cutoff || 15;
    const tick = () => {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).map((p) => [p.type, p.value]));
      const day = parts.weekday; const mins = cutoff * 60 - (+parts.hour % 24) * 60 - +parts.minute;
      const weekday = !['Sat', 'Sun'].includes(day);
      cd.textContent = weekday && mins > 0
        ? tr('dispatchWithin', 'Order within {hours}h {minutes}m for same-day dispatch', { hours: Math.floor(mins / 60), minutes: mins % 60 })
        : tr('dispatchNextDay', 'Order now for dispatch on the next working day');
    };
    tick(); const iv = setInterval(() => (root.isConnected ? tick() : clearInterval(iv)), 30000);
  }

  /* ---------- Accordions ---------- */
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-e-acc]'); if (!b) return;
    const open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', String(open));
    document.getElementById(b.getAttribute('aria-controls')).hidden = !open;
  });

  /* ---------- Complete the fit ---------- */
  root.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-e-xs-add]'); if (!b || b.getAttribute('aria-busy') === 'true') return;
    const row = b.closest('[data-e-xs]');
    const id = +(b.dataset.eXsAdd || row.querySelector('[data-e-xs-select]')?.value);
    if (!id || !window.EludeCart) return;
    b.setAttribute('aria-busy', 'true');
    try { await window.EludeCart.add([{ id, quantity: 1 }], b); b.classList.add('is-added'); b.textContent = tr('added', 'Added ✓'); }
    catch (err) { b.textContent = tr('tryAgain', 'Try again'); }
    finally { b.removeAttribute('aria-busy'); }
  });
};
init();
// Theme editor: re-bind after the section is re-rendered with new settings.
document.addEventListener('shopify:section:load', init);
}
